import React from "react";
import { useListProdukSP } from "./useListProdukSP";
import CardComponent from "../../components/Card/CardComponent";
import LogoGs from "../../Assets/GS-Logo.png";
import LogoYBI from "../../Assets/YBI-Logo.jpeg";
import LogoTBP from "../../Assets/TBP-Logo.jpeg";
import LogoMelco from "../../Assets/MELCO-Logo.png";
import LogoTIM from "../../Assets/TimLogo.png";
import LogoCBI from "../../Assets/CBI-Logo.png";
import EditLogo from "../../Assets/editLogo.png";
import LogoMitra from "../../Assets/Mitra_logo.png";
import CloseLogo from "../../Assets/close_icon.png";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import { constCustomer } from "../../util/constant";
import { validateRole } from "../../util/utilFunction";
import DeleteIcon from "../../Assets/delete_icon.png";
import Select from "react-select";
import "./listProdukSP.css";

// Kolom target per role (dipakai di tabel)
const COLUMNS_PR = [
  { label: "Target Printing", key: "targetPrint" },
  { label: "Target Punching", key: "targetPunching" },
  { label: "Target Pasang Stiker", key: "targetPasangStiker" },
];

const COLUMNS_SP = [
  { label: "Ultrasonic", key: "targetUltrasonic" },
  { label: "Test Bocor", key: "targetTestBocor" },
  { label: "Filling Plug", key: "targetFilling" },
  { label: "Pemasangan Valve&Filter", key: "targetValveFilter" },
  { label: "Putus Ronce", key: "targetPutusRonce" },
  { label: "Pasang BNW", key: "targetBnw" },
  { label: "Sortir", key: "targetSortir" },
  { label: "Pasang Handle", key: "targetPasangHandle" },
];

// Field form Edit (name = key di pickProduk)
const EDIT_FIELDS_PR = [
  { label: "Target Printing", name: "targetPrint" },
  { label: "Target Punching", name: "targetPunching" },
  { label: "Target Pasang Sticker", name: "targetPasangStiker" },
];

const EDIT_FIELDS_SP = [
  {
    label: "Ultrasonic",
    name: "targetUltrasonic",
    placeholder: "Target Ultrasonic",
  },
  {
    label: "Test Bocor",
    name: "targetTestBocor",
    placeholder: "Target Test Bocor",
  },
  {
    label: "Filling Plug",
    name: "targetFilling",
    placeholder: "Target Filling Plug",
  },
  { label: "Sortir", name: "targetSortir", placeholder: "Target Sortir" },
  {
    label: "Putus Ronce",
    name: "targetPutusRonce",
    placeholder: "Target Putus Ronce",
  },
  {
    label: "Pemasangan BNW",
    name: "targetBnw",
    placeholder: "Target Pemasangan BNW",
  },
  {
    label: "Pemasangan Valve&Filter",
    name: "targetValveFilter",
    placeholder: "Target Pemasangan Valve&Filter",
  },
  {
    label: "Pemasangan Handle",
    name: "targetPasangHandle",
    placeholder: "Target Pemasangan Handle",
  },
];

const Required = () => <span className="lps_req">*</span>;

const ListProdukSP = () => {
  const {
    dataUser,
    customer,
    setCustomer,
    Material,
    handleAddProduk,
    namaProduk,
    setNamaProduk,
    targetPrinting,
    setTargetPrinting,
    targetPunching,
    setTargetPunching,
    targetSticker,
    setTargetSticker,
    targetUltrasonic,
    setTargetUltrasonic,
    targetTestBocor,
    setTargetTestBocor,
    targetFillingPlug,
    setTargetFillingPlug,
    addNewCustomer,
    setAddNewCustomer,
    popUpTambahProduk,
    setPopUpTambahProduk,
    popUpEdit,
    setPopUpEdit,
    handlePickEdit,
    pickProduk,
    handleChangeEditProduk,
    handleKirimEditProduk,
    targetSortir,
    setTargetSortir,
    targetPutusRonce,
    setTargetPutusRonce,
    targetBnw,
    setTargetBnw,
    targetPasangHandle,
    setTargetPasangHandle,
    targetValveFilter,
    setTargetValveFilter,
    popUpDelete,
    setPopUpDelete,
    handleDeleteListBarangSp,
    pickDelete,
    setPickDelete,
    dataListBarangTemp,
  } = useListProdukSP();

  const role = validateRole();
  const isPR = role === "PR";
  const isSP = role === "SP";
  const columns = isPR ? COLUMNS_PR : COLUMNS_SP;
  const editFields = isPR ? EDIT_FIELDS_PR : EDIT_FIELDS_SP;

  const sortListProduk =
    Material &&
    Material.data.sort(function (a, b) {
      if (a.produk < b.produk) {
        return -1;
      }
      if (a.produk > b.produk) {
        return 1;
      }
      return 0;
    });

  // Field form Tambah (value + setter dari hook)
  const addFields = isPR
    ? [
        {
          label: "Target Printing",
          placeholder: "Target Printing",
          value: targetPrinting,
          set: setTargetPrinting,
        },
        {
          label: "Target Punching",
          placeholder: "Target Punching",
          value: targetPunching,
          set: setTargetPunching,
        },
        {
          label: "Target Pasang Sticker",
          placeholder: "Target Pasang Sticker",
          value: targetSticker,
          set: setTargetSticker,
        },
      ]
    : isSP
    ? [
        {
          label: "Ultrasonic",
          placeholder: "Target Ultrasonic",
          value: targetUltrasonic,
          set: setTargetUltrasonic,
        },
        {
          label: "Test Bocor",
          placeholder: "Target Test Bocor",
          value: targetTestBocor,
          set: setTargetTestBocor,
        },
        {
          label: "Filling Plug",
          placeholder: "Target Filling Plug",
          value: targetFillingPlug,
          set: setTargetFillingPlug,
        },
        {
          label: "Sortir",
          placeholder: "Target Sortir",
          value: targetSortir,
          set: setTargetSortir,
        },
        {
          label: "Putus Ronce",
          placeholder: "Target Putus Ronce",
          value: targetPutusRonce,
          set: setTargetPutusRonce,
        },
        {
          label: "Pemasangan BNW",
          placeholder: "Target Pemasangan BNW",
          value: targetBnw,
          set: setTargetBnw,
        },
        {
          label: "Pemasangan Valve&Filter",
          placeholder: "Target Pemasangan Valve&Filter",
          value: targetValveFilter,
          set: setTargetValveFilter,
        },
        {
          label: "Pemasangan Handle",
          placeholder: "Target Pemasangan Handle",
          value: targetPasangHandle,
          set: setTargetPasangHandle,
        },
      ]
    : [];

  return (
    <div className="container_memo_ppic lps">
      {/* ===== Popup Edit ===== */}
      {popUpEdit ? (
        <PopUpComponent
          style={{
            marginTop: "calc(116vh - 100vh - 10px)",
            overflowY: "scroll",
            height: "70vh",
          }}
        >
          <div className="lps_popup_head">
            <p className="lps_popup_title">{pickProduk.produk}</p>
            <img
              className="lps_popup_close"
              src={CloseLogo}
              onClick={() => setPopUpEdit(false)}
              alt="close"
            />
          </div>

          <div className="lps_form_grid">
            {editFields.map((f) => (
              <div className="lps_field" key={f.name}>
                <p className="lps_label">
                  {f.label}
                  <Required />
                </p>
                <input
                  type="number"
                  className="lps_input"
                  placeholder={f.placeholder || f.label}
                  name={f.name}
                  value={pickProduk[f.name]}
                  onChange={(e) => handleChangeEditProduk(e)}
                />
              </div>
            ))}
          </div>

          <div className="lps_field" style={{ marginTop: "14px" }}>
            <p className="lps_label">Polos</p>
            <Select
              options={dataListBarangTemp && dataListBarangTemp.data}
              value={pickProduk?.barangJadi || ""}
              onChange={(selectedOption) =>
                handleChangeEditProduk(selectedOption, "barangJadi")
              }
            />
          </div>

          <div className="lps_popup_footer">
            <button
              className="lps_btn_primary"
              onClick={() => handleKirimEditProduk()}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      {/* ===== Popup Hapus ===== */}
      {popUpDelete ? (
        <PopUpComponent>
          <div className="lps_popup_head">
            <p className="lps_popup_title" style={{ fontWeight: 400 }}>
              Apakah kamu yakin ingin menghapus produk{" "}
              <b>{pickDelete.produk}</b> ini?
            </p>
            <img
              className="lps_popup_close"
              src={CloseLogo}
              onClick={() => setPopUpDelete(false)}
              alt="close"
            />
          </div>
          <div className="lps_popup_footer">
            <button
              className="lps_btn_primary"
              onClick={() => handleDeleteListBarangSp()}
            >
              Hapus
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      {/* ===== Popup Tambah ===== */}
      {popUpTambahProduk ? (
        <PopUpComponent
          style={{
            overflowY: "scroll",
            marginTop: "calc(110vh - 100vh - 20px)",
            height: "80vh",
          }}
        >
          <div className="lps_popup_head">
            <p className="lps_popup_title">Tambah Produk</p>
            <img
              className="lps_popup_close"
              src={CloseLogo}
              onClick={() => setPopUpTambahProduk(false)}
              alt="close"
            />
          </div>

          <div className="lps_form_grid">
            <div className="lps_field">
              <p className="lps_label">
                Perusahaan
                <Required />
              </p>
              <select
                value={addNewCustomer}
                onChange={(e) => setAddNewCustomer(e.target.value)}
                className="lps_input"
              >
                <option value="Pilih Perusahaan" disabled>
                  Pilih Perusahaan
                </option>
                {constCustomer &&
                  constCustomer.map((data) => (
                    <option key={data} value={data}>
                      {data}
                    </option>
                  ))}
              </select>
            </div>

            <div className="lps_field">
              <p className="lps_label">
                Nama Produk
                <Required />
              </p>
              <input
                type="text"
                className="lps_input"
                placeholder="Masukkan Nama Produk"
                value={namaProduk}
                onChange={(e) => setNamaProduk(e.target.value)}
              />
            </div>

            {addFields.map((f) => (
              <div className="lps_field" key={f.label}>
                <p className="lps_label">
                  {f.label}
                  <Required />
                </p>
                <input
                  type="number"
                  className="lps_input"
                  placeholder={f.placeholder}
                  value={f.value}
                  onChange={(e) => f.set(e.target.value)}
                />
              </div>
            ))}
          </div>

          <div className="lps_popup_footer">
            <button
              className="lps_btn_primary"
              onClick={() => handleAddProduk()}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      {/* ===== Header ===== */}
      <div className="lps_header">
        <p className="lps_title">LIST PRODUK SP</p>
        <button
          className="lps_btn_add"
          onClick={() => setPopUpTambahProduk(true)}
        >
          + Tambah
        </button>
      </div>

      {/* ===== Pilih customer ===== */}
      <div className="lps_customer_list">
        <CardComponent
          active={customer === "GS"}
          title="PT. GS"
          logo={LogoGs}
          onClick={() => setCustomer("GS")}
        />
        <CardComponent
          active={customer === "YBI"}
          title="PT. YBI"
          logo={LogoYBI}
          onClick={() => setCustomer("YBI")}
        />
        <CardComponent
          active={customer === "TBP"}
          title="PT. TBP"
          logo={LogoTBP}
          onClick={() => setCustomer("TBP")}
        />
        <CardComponent
          active={customer === "MELCO"}
          title="PT. MELCO"
          logo={LogoMelco}
          onClick={() => setCustomer("MELCO")}
        />
        <CardComponent
          active={customer === "CBI"}
          title="PT. CBI"
          logo={LogoCBI}
          onClick={() => setCustomer("CBI")}
        />
        {dataUser.tim === 2 ? (
          <CardComponent
            active={customer === "MITRA"}
            title="PT. MITRA"
            logo={LogoMitra}
            onClick={() => setCustomer("MITRA")}
          />
        ) : (
          ""
        )}
        <CardComponent
          active={customer === "TIM"}
          title="PT. TIM"
          logo={LogoTIM}
          onClick={() => setCustomer("TIM")}
        />
      </div>

      {/* ===== Tabel ===== */}
      <p className="lps_section_title">LIST PRODUK PT. {customer}</p>
      <div className="lps_table_wrap">
        <table className="lps_table">
          <thead>
            <tr>
              <th className="lps_col_no">No.</th>
              <th>Nama Produk</th>
              {columns.map((c) => (
                <th key={c.key} className="lps_num">
                  {c.label}
                </th>
              ))}
              <th>Polos</th>
              <th className="lps_col_aksi">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {sortListProduk && sortListProduk.length > 0 ? (
              sortListProduk.map((data, index) => (
                <tr key={data.id ?? index}>
                  <td className="lps_col_no">{index + 1}</td>
                  <td className="lps_produk">{data.produk}</td>
                  {columns.map((c) => (
                    <td key={c.key} className="lps_num">
                      {data[c.key]} Pcs
                    </td>
                  ))}
                  <td className="lps_polos">{data.barangJadi?.label || ""}</td>
                  <td>
                    <div className="lps_actions">
                      <button
                        className="lps_icon_btn lps_edit"
                        onClick={() => handlePickEdit(data)}
                        title="Edit"
                      >
                        <img src={EditLogo} alt="edit" />
                      </button>
                      <button
                        className="lps_icon_btn lps_delete"
                        onClick={() => {
                          setPickDelete(data);
                          setPopUpDelete(true);
                        }}
                        title="Hapus"
                      >
                        <img src={DeleteIcon} alt="delete" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="lps_empty" colSpan={columns.length + 4}>
                  Belum ada produk
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListProdukSP;
